import Home from './pages/Home.vue'
import About from './pages/About.vue'
import Clients from './pages/Clients.vue'
import Contact from './pages/Contact.vue'
import Projects from './pages/Projects.vue'
import Cases from './pages/Cases.vue'
import PageNotFound from './pages/PageNotFound.vue'

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'

Vue.use(VueHead)

Vue.use(VueRouter)
var router = new VueRouter({
    hashbang:false,
    history: true
})

router.beforeEach(() => {
    router.app.showMenu(false);
})

router.map({
    '*': {
        name: 'not-found',
        component: PageNotFound
    },
    '/': {
        name: 'home',
        component: Home
    },
    '/a-guco': {
        name: 'about',
        component: About
    },
    '/clientes': {
        name: 'clients',
        component: Clients
    },
    '/cases': {
        name: 'cases',
        component: Cases
    },
    '/projetos': {
        name: 'projects',
        component: Projects
    },
    '/contato': {
        name: 'contact',
        component: Contact
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js